import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4de22218&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=4de22218&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de22218",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/xudong/bs_workspace/RuoYi-Vue/hss_-warning_-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4de22218')) {
      api.createRecord('4de22218', component.options)
    } else {
      api.reload('4de22218', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4de22218&scoped=true", function () {
      api.rerender('4de22218', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dbs/index.vue"
export default component.exports